module.exports = __webpack_public_path__ + "static/media/18.1dfd1288.wav";